import { Routes } from '@angular/router';
import { authGuard } from './core/shared/guards/auth.guard';

export const LOGIN_ROUTE = "login";
export const AUTH_CALLBACK_ROUTE = "auth/callback";
export const PNS_LIST_ROUTE = "pns";
export const UNAUTHORIZED_ROUTE = "unauthorized";

export const routes: Routes = [
  {
    path: LOGIN_ROUTE,
    loadComponent: () => import('./features/auth/components/login/login').then((c) => c.Login),
  },
  {
    path: AUTH_CALLBACK_ROUTE,
    loadComponent: () =>
      import('./features/auth/components/login-callback/login-callback').then((c) => c.LoginCallback),
  },
  {
    path: PNS_LIST_ROUTE,
    loadComponent: () => import('./features/psn-analysis/components/pns-list/pns-list').then((c) => c.PnsList),
    data: { isListPage: true, title: 'TITLE' },
    canActivate: [authGuard],
  },
  {
    path: `${PNS_LIST_ROUTE}/:id`,
    loadComponent: () => import('./features/psn-analysis/components/pns-detail/pns-detail').then((c) => c.PnsDetail),
    canActivate: [authGuard],
  },
  {
    path: UNAUTHORIZED_ROUTE,
    loadComponent: () => import('./features/unauthorized/unauthorized').then((c) => c.Unauthorized),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE,
  },
];
